import { Controller } from "@hotwired/stimulus"

// Mobile navigation panel.
export default class extends Controller {
  static targets = ["panel"]

  toggle() {
    this.panelTarget.hidden = !this.panelTarget.hidden
  }
}
